import React from "react";
import { Link } from "react-router-dom";
import PageSeo from "components/Seo/PageSeo";
import PageHero from "components/PageHero/PageHero";
import "components/Home/homeShared.css";
import "./notFound.css";

const NotFound = () => (
  <main className="not-found-page">
    <PageSeo
      title="Page Not Found"
      description="The page you requested could not be found on Ace Gymnastics."
      path="/404"
      noindex
    />
    <PageHero
      title="Page not found"
      subtitle="That link may be outdated or mistyped. Head back to our homepage or explore programs and events."
      imageAlt="Ace Gymnastics facility"
    />
    <section className="home-section not-found-page__actions" aria-label="Helpful links">
      <div className="home-section__inner not-found-page__inner">
        <Link to="/" className="home-btn home-btn--primary">
          Back to home
        </Link>
        <Link to="/programs/program-details/" className="home-btn home-btn--outline">
          View programs
        </Link>
        <Link to="/contact" className="home-btn home-btn--outline">
          Contact us
        </Link>
      </div>
    </section>
  </main>
);

export default NotFound;
